import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { cplatApiV3, CPLAT_API_ROUTES } from '@/api';
import type { DeleteRequest } from '@/types/productOptimization';

type DeleteResponse = {
  code: string;
  message: string;
  data: null;
};

export const useDeleteOptimization = () => {
  return useMutation<AxiosResponse<DeleteResponse>, AxiosError, DeleteRequest>({
    mutationFn: (body) =>
      cplatApiV3.post<DeleteResponse>(CPLAT_API_ROUTES.productOptimizationDelete, body),
  });
};
